// extracted by mini-css-extract-plugin
export default {"alertBody":"style_alertBody__ccV6f","subContainer":"style_subContainer__9xgX2"};